<div class="form-group">
  @if (showLabel) {
    <label
      [innerHtml]="(question?.question_copy || question?.email_version) && !showControlLabel ? (question?.question_copy || question?.email_version) : controlLabel" class="form-group__label">
    </label>
  }
  <div class="form-group__calrange">
    <div class="form-group__calrange-start">
      <app-question-date-picker
        [question]="question"
        [showLabel]="true"
        [showControlLabel]="true"
        [controlLabel]="startLabel"
        [dateFormat]="dateFormat"
        [category]="category"
        [numberMonths]="numberMonths"
        [showOtherMonths]="showOtherMonths"
        [displayInline]="displayInline"
        [showIcon]="showIcon"
        [minDate]="startMinDate"
        [maxDate]="startMaxDate"
        [initialDate]="startInitialDate"
        (questionAnswer)="onDate1Change($event)">
      </app-question-date-picker>
    </div>
    <div class="form-group__calrange-to">
      <!-- gap-->
    </div>
    <div class="form-group__calrange-end">
      <app-question-date-picker
        [question]="question"
        [showLabel]="true"
        [showControlLabel]="true"
        [controlLabel]="endLabel"
        [dateFormat]="dateFormat"
        [category]="category"
        [numberMonths]="numberMonths"
        [showOtherMonths]="showOtherMonths"
        [displayInline]="displayInline"
        [showIcon]="showIcon"
        [minDate]="endMinDate"
        [maxDate]="endMaxDate"
        [initialDate]="endInitialDate"
        (questionAnswer)="onDate2Change($event)">
      </app-question-date-picker>
    </div>
  </div>
</div>
